import { Form } from '@unform/web';
import styled from 'styled-components';

import { breakpoints } from '~/styles/tools/breakpoints';

export const FormWrapper = styled(Form)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 2.4rem;
  column-gap: 6.4rem;

  @media (max-width: ${breakpoints.medium}) {
    display: flex;
    flex-direction: column;
  }
`;

export const InputBlock = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  > p & .input_mask {
    font-size: 1.4rem;
    opacity: 0.65;
    color: ${({ theme }) => theme.colors.black};
    user-select: none;
    padding: 0 0 0.6rem 1.2rem;
  }

  .input_mask {
    padding: 1.6rem 3.4rem;

    border: 0.5px solid #707070;
    border-radius: 4rem;
  }
`;

export const Divider = styled.div`
  grid-column: 1 / -1;
  height: 2px;
  background-color: rgba(0, 0, 0, 0.3);
`;
